(() => {
  'use strict';
  if (window.__ROCKY_PRODUCT_STORY__) return;
  window.__ROCKY_PRODUCT_STORY__ = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let activeOpener = null;
  let closeTimer = null;

  const initStory = root => {
    const sections = [];
    if (root?.matches?.('[data-rk6-story]')) sections.push(root);
    root?.querySelectorAll?.('[data-rk6-story]').forEach(section => sections.push(section));

    sections.forEach(section => {
      if (section.dataset.rk6StoryReady === 'true') return;
      section.dataset.rk6StoryReady = 'true';

      const cards = [...section.querySelectorAll('[data-rk6-story-card]')];
      const videos = cards.map(card => card.querySelector('[data-rk6-story-video]')).filter(Boolean);

      const hydrateVideo = video => {
        const source = video?.querySelector('source[data-src]');
        if (!source) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();
      };

      const pauseVideo = video => {
        video.pause();
        video.closest('[data-rk6-story-card]')?.classList.remove('is-playing');
        const toggle = video.closest('[data-rk6-story-card]')?.querySelector('[data-rk6-story-toggle]');
        toggle?.setAttribute('aria-label', 'Videoyu oynat');
      };

      const playVideo = video => {
        videos.forEach(item => {
          if (item !== video) pauseVideo(item);
        });
        hydrateVideo(video);
        video.muted = true;
        video.play().then(() => {
          video.closest('[data-rk6-story-card]')?.classList.add('is-playing');
          video.closest('[data-rk6-story-card]')?.querySelector('[data-rk6-story-toggle]')?.setAttribute('aria-label', 'Videoyu durdur');
        }).catch(() => pauseVideo(video));
      };

      cards.forEach(card => {
        const video = card.querySelector('[data-rk6-story-video]');
        const toggle = card.querySelector('[data-rk6-story-toggle]');
        if (!video || !toggle) return;

        toggle.addEventListener('click', () => playVideo(video));
        video.addEventListener('click', () => {
          if (video.paused) playVideo(video);
          else pauseVideo(video);
        });
        card.addEventListener('mouseenter', () => {
          if (!reduceMotion && window.matchMedia('(hover: hover)').matches) playVideo(video);
        });
      });

      if (!reduceMotion && videos[0] && 'IntersectionObserver' in window) {
        const sectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) playVideo(videos[0]);
            else videos.forEach(pauseVideo);
          });
        }, { threshold: 0.28 });
        sectionObserver.observe(section);
      }

      const rail = section.querySelector('[data-rk6-story-rail]');
      let scrollTimer;
      rail?.addEventListener('scroll', () => {
        if (reduceMotion) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const railCenter = rail.getBoundingClientRect().left + rail.clientWidth / 2;
          const closest = cards.reduce((winner, card) => {
            const rect = card.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - railCenter);
            return !winner || distance < winner.distance ? { card, distance } : winner;
          }, null);
          const video = closest?.card.querySelector('[data-rk6-story-video]');
          if (video) playVideo(video);
        }, 120);
      }, { passive: true });

      section.querySelector('[data-rk6-story-shop]')?.addEventListener('click', () => {
        const target = document.querySelector('[data-rk4-product] .rk4-options') || document.querySelector('[data-rk4-product] [data-rk4-buy-row]');
        target?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    });
  };

  const initDock = () => {
    const dock = document.querySelector('[data-rk6-story-dock]');
    const rail = dock?.querySelector('[data-rk6-story-dock-rail]');
    const player = document.querySelector('[data-rk6-story-player]');
    if (!dock || !rail || !player || dock.dataset.rk6StoryDockReady === 'true') return;

    const cards = [...document.querySelectorAll('[data-rk6-story-card]')];
    const stories = cards.map(card => {
      const video = card.querySelector('[data-rk6-story-video]');
      const source = video?.querySelector('source');
      return {
        src: source?.getAttribute('data-src') || source?.getAttribute('src') || video?.currentSrc || video?.getAttribute('src') || '',
        poster: video?.getAttribute('poster') || card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '',
        kicker: card.querySelector('.rk6-story-card__badge')?.textContent?.trim() || 'GERÇEK KULLANIM',
        title: card.querySelector('.rk6-story-card__body h3')?.textContent?.trim() || 'Rocky hareket halinde'
      };
    }).filter(story => story.src);
    if (!stories.length) return;

    dock.dataset.rk6StoryDockReady = 'true';
    dock.hidden = false;

    const playerVideo = player.querySelector('[data-rk6-player-video]');
    const playerTitle = player.querySelector('[data-rk6-player-title]');
    const playerKicker = player.querySelector('[data-rk6-player-kicker]');
    const playerCount = player.querySelector('[data-rk6-player-count]');
    const playButton = player.querySelector('[data-rk6-player-play]');
    const soundButton = player.querySelector('[data-rk6-player-sound]');
    const dots = player.querySelector('[data-rk6-player-dots]');
    const device = player.querySelector('.rk6-story-player__device');
    let activeIndex = 0;
    let touchStartX = 0;

    const setPlayingState = playing => {
      player.classList.toggle('is-playing', playing);
      playButton?.setAttribute('aria-label', playing ? 'Videoyu durdur' : 'Videoyu oynat');
    };

    const setMutedState = muted => {
      player.classList.toggle('is-muted', muted);
      soundButton?.setAttribute('aria-label', muted ? 'Sesi aç' : 'Sesi kapat');
    };

    const playCurrent = () => {
      if (!playerVideo) return;
      playerVideo.play().then(() => setPlayingState(true)).catch(() => setPlayingState(false));
    };

    const showStory = (index, autoplay = true) => {
      activeIndex = (index + stories.length) % stories.length;
      const story = stories[activeIndex];
      if (!playerVideo) return;
      playerVideo.pause();
      playerVideo.src = story.src;
      playerVideo.poster = story.poster;
      playerVideo.load();
      playerTitle.textContent = story.title;
      playerKicker.textContent = story.kicker;
      playerCount.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(stories.length).padStart(2, '0')}`;
      [...dots.children].forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
      if (autoplay && !reduceMotion) playCurrent();
      else setPlayingState(false);
    };

    const closePlayer = () => {
      window.clearTimeout(closeTimer);
      playerVideo?.pause();
      setPlayingState(false);
      player.classList.remove('is-open');
      player.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rk6-story-open');
      closeTimer = window.setTimeout(() => {
        player.hidden = true;
        activeOpener?.focus();
      }, reduceMotion ? 0 : 180);
    };

    const openPlayer = (index, opener) => {
      window.clearTimeout(closeTimer);
      activeOpener = opener;
      cards.forEach(card => card.querySelector('[data-rk6-story-video]')?.pause());
      player.hidden = false;
      player.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rk6-story-open');
      playerVideo.muted = true;
      setMutedState(true);
      showStory(index);
      window.requestAnimationFrame(() => {
        player.classList.add('is-open');
        player.querySelector('.rk6-story-player__close')?.focus();
      });
    };

    stories.forEach((story, index) => {
      const item = document.createElement('div');
      item.className = 'rk6-story-dock__item';

      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `${story.title} videosunu aç`);

      const media = document.createElement('span');
      media.className = 'rk6-story-dock__media';
      const image = document.createElement('img');
      image.src = story.poster;
      image.alt = '';
      image.loading = index === 0 ? 'eager' : 'lazy';
      const play = document.createElement('i');
      play.setAttribute('aria-hidden', 'true');
      media.append(image, play);

      const label = document.createElement('small');
      label.textContent = story.kicker;
      button.append(media, label);
      button.addEventListener('click', () => openPlayer(index, button));
      item.append(button);
      rail.append(item);

      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `${index + 1}. videoya geç`);
      dot.addEventListener('click', () => showStory(index));
      dots.append(dot);
    });

    player.querySelectorAll('[data-rk6-player-close]').forEach(button => button.addEventListener('click', closePlayer));
    player.querySelector('[data-rk6-player-prev]')?.addEventListener('click', () => showStory(activeIndex - 1));
    player.querySelector('[data-rk6-player-next]')?.addEventListener('click', () => showStory(activeIndex + 1));
    playButton?.addEventListener('click', () => {
      if (playerVideo.paused) playCurrent();
      else playerVideo.pause();
    });
    soundButton?.addEventListener('click', () => {
      playerVideo.muted = !playerVideo.muted;
      setMutedState(playerVideo.muted);
    });
    playerVideo?.addEventListener('play', () => setPlayingState(true));
    playerVideo?.addEventListener('pause', () => setPlayingState(false));
    playerVideo?.addEventListener('click', () => {
      if (playerVideo.paused) playCurrent();
      else playerVideo.pause();
    });

    device?.addEventListener('touchstart', event => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    device?.addEventListener('touchend', event => {
      const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(distance) < 42) return;
      showStory(distance > 0 ? activeIndex - 1 : activeIndex + 1);
    }, { passive: true });

    document.addEventListener('keydown', event => {
      if (player.hidden) return;
      if (event.key === 'Escape') closePlayer();
      if (event.key === 'ArrowLeft') showStory(activeIndex - 1);
      if (event.key === 'ArrowRight') showStory(activeIndex + 1);
      if (event.key !== 'Tab') return;
      const focusable = [...player.querySelectorAll('button:not([disabled])')];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
  };

  const init = () => {
    initStory(document);
    initDock();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => {
    initStory(event.target);
    initDock();
  });
})();
